var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-file-input',{directives:[{name:"validate",rawName:"v-validate",value:({
        required: true,
    }),expression:"{\n        required: true,\n    }"}],class:{
        'is-invalid': _vm.errors.has('utility bill scan copy'),
    },attrs:{"input-id":"utility","input-label":"UTILITY BILL SCAN COPY","placeholder":_vm.originalFileName || 'Select scan copy (JPG, PNG or TIFF file)',"drop-placeholder":"Drop file here...","file-type":"utility","accept":"image/*","data-vv-name":"utility bill scan copy"},on:{"update:originalFileName":_vm.updateOriginalFileName},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }